export default defineNuxtPlugin(function (nuxtApp) {
  nuxtApp.$gtm.init(nuxtApp.$config.public.gtm_id);
});